import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {SVGIcon} from '@homeaway/react-svg';
import {GLOBE__24} from '@homeaway/svg-defs/lib/defs/GLOBE__24';
import './PreferencePanel.less';

class PreferencePanel extends Component {
    static propTypes = {
        currency: PropTypes.object,
        currencyName: PropTypes.string,
        currencySymbol: PropTypes.string,
        countryCode: PropTypes.string,
        locale: PropTypes.string,
        languageName: PropTypes.string,
        renderCountryLanguageSelector: PropTypes.bool,
        renderCurrencySelector: PropTypes.bool,
        onClick: PropTypes.func
    }
    static defaultProps = {
        currency: {code: 'USD', symbol: 'US$', name: 'US Dollar'},
        currencyName: 'US Dollar',
        currencySymbol: '$',
        countryCode: 'USA',
        locale: 'en_US',
        languageName: 'English',
        renderCountryLanguageSelector: true,
        renderCurrencySelector: true,
        onClick: () => {}
    }
    constructor(props) {
        super(props);
    }

    render() {
        const {countryCode, locale, languageName, currency, languageSelectorOnly, renderCountryLanguageSelector, renderCurrencySelector, onClick} = this.props;
        let languageCode = locale.substr(0, 2).toUpperCase();
        return (
            <div className="GlobalizationSelectorPreference" onClick={onClick} onKeyPress={onClick} role="button" tabIndex="0" aria-haspopup="true">
                <div className="clearfix">
                    {renderCountryLanguageSelector &&
                    <div className="GlobalizationSelectorPreference__item">
                        {!languageSelectorOnly &&
                        <div className="GlobalizationSelectorPreference__item__country GlobalizationSelectorPreference__item__language">
                            <i className={`flag-${countryCode} GlobalizationSelectorPreference__item__flag`} aria-hidden="true"/>
                            <span className="GlobalizationSelectorPreference__item__text">
                                <span className="visible-lg-inline">{languageName}</span>
                                <span className="hidden-lg">{languageCode}</span>
                            </span>
                        </div>}
                        {languageSelectorOnly &&
                        <div className="GlobalizationSelectorPreference__item__language">
                            <SVGIcon className="GlobalizationSelectorPreference__svg" markup={GLOBE__24} inlineFlex/>
                            <span className="GlobalizationSelectorPreference__item__text">
                                <span className="visible-lg-inline">{languageName}</span>
                                <span className="hidden-lg">{languageCode}</span>
                            </span>
                        </div>}
                    </div>
                    }
                    {renderCountryLanguageSelector && renderCurrencySelector &&
                    <div className="GlobalizationSelectorPreference__item GlobalizationSelectorPreference__item__separator" />
                    }
                    {renderCurrencySelector &&
                    <div className="GlobalizationSelectorPreference__item">
                        <div>{`${currency.code } (${ currency.symbol })`}</div>
                    </div>
                    }
                </div>
            </div>
        );
    }
}

export default PreferencePanel;
